import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { InteractiveText } from "@silvertours/front-shared";
var DeleteButtonInteractiveText = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ _jsx(InteractiveText, {
        className: className,
        size: "small",
        inline: true,
        textColor: "current",
        children: children
    });
};
export { DeleteButtonInteractiveText };
